import React from 'react';
import GameScoreBoard from '../GameScoreBoard.js';
import {_GPY,__GPYPost} from '../../../env.js'

import GpyToggleButton from '../lib/GpyToggleButton.js';
import GpyTime from '../lib/GpyTime.js';
import GpyScoreButton from '../lib/GpyScoreButton.js';
import GpyScoreField from '../lib/GpyScoreField.js';
import GpyTeamSelect from '../lib/GpyTeamSelect.js'
import GpyGameLog from '../lib/GpyGameLog.js';
import GpyTeamList from '../lib/GpyTeamList.js';

import WaitCube from '../../../WaitCube';

import ScoreboardGameSelector from '../lib/ScoreboardGameSelector.js';
import ScoreboardDisplayPanel from '../lib/ScoreboardDisplayPanel.js';
import ScoreboardFreeTextPanel from '../lib/ScoreboardFreeTextPanel.js';
import ScoreboardTeamScorePanel from '../lib/ScoreboardTeamScorePanel.js';
import ScoreboardAdvertisementTournament from '../lib/ScoreboardAdvertisementTournament.js';
import ScoreboardTeamDefaultButtons from '../lib/ScoreboardTeamDefaultButtons.js';
import ScoreboardPeriods from '../lib/ScoreboardPeriods.js';
import ScoreboardSetupSingleSelect from '../lib/ScoreboardSetupSingleSelect.js';
import ScoreboardClock from '../lib/ScoreboardClock.js';
import ScoreboardStats from '../lib/ScoreboardStats.js';
import GpyKeybindingButton from '../lib/GpyKeybindingButton.js';

class SBCricket extends GameScoreBoard {

	constructor(props) {
		super(props);
		var s = super.getGPYState("Cricket");
		s.NAME = "Cricket";
		this.state = s;
		s.currentSet = 0;

		s.defaultDataStore = {
			setup : {
				overs:20, // 50
			},
			innings: [
									{
										overs : [ // 20 or 50 Overs
															{ balls:[
																		{
																			isNoball: true,
																			runs : 0,
																			isWicket : false,
																			wicketType : "",
																			striker : { id:-1 },
																			nonstriker : { id:-1 },
																			bowler : { id:-1 },
																		}
																]
															}
													]
									},
									{ overs:[] }
				     ],
		}
		s.dataStore = JSON.parse(JSON.stringify(this.state.defaultDataStore))

		s.mainClockDependenciesClocks=[
		  // {clock : this.state.NAME+'_countdown', button : this.state.NAME+'_button_start_stop_countdown'},
	  ];
		s.currentPeriodIndex=1;
		s.currentBall = 1;
		s.currentOver = 1;
		s.currentWicketType = "";
		s.currentIsNoball = false;
		s.currentIsWicket = false;
	}


  /** the default delegate methods - works with standard state names **/
	componentDidMount() {
		super.componentDidMount();
		super.loadUserConfig().then((res)=>{
			super.getGamesStates();
			super.getGames();
		});
	}

	setBallData(){

			console.log("Inning:",this.state.currentSet);
			console.log("Over:",this.state.currentOver);
			console.log("Ball:",this.state.currentBall);

		  var ds = this.state.dataStore;
			if( ds.innings !== undefined) {
					if(ds.innings[this.state.currentSet] === undefined) {
						ds.innings[this.state.currentSet]  = [];
					}
				  if(ds.innings[this.state.currentSet].overs===undefined) {
					 	ds.innings[this.state.currentSet].overs = []
				  }
					var over = ds.innings[this.state.currentSet].overs[this.state.currentOver];
					if(over===undefined) {
						over = { balls:[] };
						ds.innings[this.state.currentSet].overs[this.state.currentOver] = over;
					}
					if( ds.innings[this.state.currentSet].overs[this.state.currentOver].balls === undefined) {
						ds.innings[this.state.currentSet].overs[this.state.currentOver].balls = [];
					}
					var ball = ds.innings[this.state.currentSet].overs[this.state.currentOver].balls[this.state.currentBall];
					if(ball === undefined) {
						ball = {isNoball: false, runs : 0, isWicket : false, wicketType : "", striker : { id:-1 }, nonstriker : { id:-1 },bowler : { id:-1 }}
					}
					ball.runs = this.state.components.runs.getScore();
					ball.striker = super.getRoleSetup("striker")!==undefined ? super.getRoleSetup("striker") : -1 ;
					ball.nonstriker = super.getRoleSetup("nonstriker")!==undefined ? super.getRoleSetup("nonstriker") : -1 ;
					ball.bowler = super.getRoleSetup("bowler")!==undefined ? super.getRoleSetup("bowler") : -1 ;
					ball.wicketType = this.state.currentWicketType;
					ball.isNoball = this.state.currentIsNoball;
					ball.isWicket = this.state.currentIsWicket;
					ds.innings[this.state.currentSet].overs[this.state.currentOver].balls[this.state.currentBall] = ball;
			}
			console.log("DS:",ds);
			this.setState({dataStore:ds},()=>super.storeData());
	}

	openBallData() {
			var ds = this.state.dataStore;
			if( ds.innings !== undefined && ds.innings[this.state.currentSet] !== undefined) {
				if( ds.innings[this.state.currentSet].overs !== undefined && ds.innings[this.state.currentSet].overs[this.state.currentOver] !== undefined ) {
					var over = ds.innings[this.state.currentSet].overs[this.state.currentOver];
					if( over.balls !== undefined && over.balls[this.state.currentBall] !== undefined ) {
						var ball = over.balls[this.state.currentBall];

						console.log("Ball",ball);
						if(ball!== null && ball!==undefined) {
							this.state.components.runs.setScore(ball.runs);
							super.setUserRole("striker",ball.striker);
							super.setUserRole("nonstriker",ball.nonstriker);
							super.setUserRole("bowler",ball.bowler);
							this.setState({currentIsNoball:ball.isNoball,currentIsWicket:ball.isWicket});
					  }
					}
				}
			};
	}

	componentWillUnmount() {
		 super.componentWillUnmount();
	}
	getMainClock() {
 		return super.getMainClock();
	}
	togglePlay(method) {
		return super.togglePlay(method);
	}


  /** Init yout default Datastore **/
	initDataStore(id) {
		var ds = this.state.dataStore;
		this.setState({dataStore:ds});
	}

	render () {
		const sponsorLogo = this.state.currentGame.sponsorLogo!==undefined&&this.state.currentGame.sponsorLogo!==''?this.state.currentGame.sponsorLogo:"empty.png";
		if(!this.state.defaultValuesLoaded) {
			return (<WaitCube/>);
		}

	  return (
			<>

					<ScoreboardGameSelector scoreboard={this} beta={true}/>

	{this.state.currentGame.id > 0 ?

					<div className="row p-3">
					 <div className="col" style={{maxWidth:this.state.displayWidth+"px"}}>

								<ScoreboardDisplayPanel scoreboard={this} />

								<div className="row">
											<div className="col-12"><strong>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_overs_title')}</strong></div>
											<div className="col-6">
															<div className="row">
																<div className="col-12">Over</div>
																		<div className="col-12">
																				<GpyScoreButton scoreboard={this} state="currentOver" min={1} max={50} scoreType="ring" onChangeScore={(s)=>{
																						if(this.state.components.currentBall!==undefined) {
																							this.state.components.currentBall.setScore(1);
																						}
																						this.setState({currentOver:s},()=>{
																							this.openBallData();
																						});
																				}}/>
																		</div>
														  </div>
											</div>
											<div className="col-6">
											<div className="row">
												<div className="col-12">Ball</div>
													<div className="col-12">
																<GpyScoreButton scoreboard={this} stateName="currentBall" min={1} max={50} onChangeScore={(s)=>{
																	console.log("onChnageScore",s);
																		this.setState({currentBall:s},()=>{
																			this.openBallData();
																		});
																}}/>
													</div>
												 </div>
											</div>
								</div>

								<div className="row">
								<div className="col-12">
									<strong>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_runs_title')}</strong>
								</div>
								<div className="col-6">
									<GpyScoreButton scoreboard={this} stateName="runs" min={0} onChangeScore={(s)=>{
									}}/>
								</div>

								<div className="col-3 p-1">
								<GpyKeybindingButton className={"btn btn-sm btn-block btn-secondary"} scoreboard={this.props.scoreboard} title={"+4"} stateName={this.props.stateName+"_runs_4"} onClick={(e)=>{
									if(this.state.components.runs!==undefined) {
											this.state.components.runs.setScore(4,()=>this.forceUpdate());
									}
								}} />
								</div>
								<div className="col-3 p-1">
								<GpyKeybindingButton className={"btn btn-sm btn-block btn-secondary"} scoreboard={this.props.scoreboard} title={"+6"} stateName={this.props.stateName+"_runs_6"} onClick={(e)=>{
										if(this.state.components.runs!==undefined) {
											this.state.components.runs.setScore(6,()=>this.forceUpdate());
											this.forceUpdate();
										}
								}} />
								</div>

								<div className="col-12">
									<ScoreboardSetupSingleSelect col="4" scoreboard={this} default={"Type1"} items={["Type1","Type2","Type3","Type4","Type5","Type6"]}
									onChange={(item)=>{
										 // super.setUserRole("striker",undefined);
										 var noball = this.getComponent(this.getName()+"_button_noball");
										 if(noball!==undefined) noball.onDeactivate();

										 if(this.state.components.runs!==undefined) {
												this.state.components.runs.setScore(1,()=>this.forceUpdate());
									   }
										 if(item===undefined) { //unselect
											 this.setState({currentIsWicket:false,currentWicketType:undefined,currentIsNoball:false});
										 } else {
											 this.setState({currentIsWicket:true,currentWicketType:item,currentIsNoball:false});
										 }
									}}
									stateName={this.getName()+"_button_wicketType_selector"}
									name="wicketType" />
								</div>

								<div className="col-12 p-1">
										<GpyToggleButton className={"btn btn-sm btn-block btn-primary"} title={"No Ball"}
										onDeactivate={() => {
												this.setState({currentIsNoball:false,currentIsWicket:false,currentWicketType:undefined});
												return {visible: false};
											}
										}
										onActivate={() => {
												var wselect = this.getComponent(this.getName()+"_button_wicketType_selector");
												if(wselect!==undefined) wselect.deselectAll();

												if(this.state.components.runs!==undefined) {
													this.state.components.runs.setScore(1,()=>this.forceUpdate());
												}
												this.setState({currentIsNoball:true,currentIsWicket:false,currentWicketType:undefined});
												return {visible: true};
											}
										}
										scoreboard={this}
										getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
										stateName={this.getName()+"_button_noball"}

										onClick={(e)=>{

										}}/>
								</div>

								<div className="col-12 p-1">


									{this.state.currentIsNoball?<>
										<div className="row">
												<div className="col-12 font-bold"><strong>NoBall</strong></div>
										</div>
									</>:<></>}

									{this.state.currentIsWicket?<>
										<div className="row">
												<div className="col-12"><strong>WICKET: {this.state.currentWicketType}</strong></div>
										</div>
									</>:<></>}


									<div className="row">
												<div className="col-4">Over:{this.state.currentOver}</div>
												<div className="col-4">Ball:{this.state.currentOver}</div>
												<div className="col-4">Runs:{this.state.components.runs!==undefined?this.state.components.runs.getScore():"-"}</div>
									</div>

									<div className="row">
												<div className="col-6">Striker:</div>
												<div className="col-6">{super.getRoleSetup("striker")!==undefined ? _GPY.toPlayerName( super.getPlayerById(super.getRoleSetup("striker")) ):"-"}</div>
										</div>
										<div className="row">
												<div className="col-6">NonStriker:</div>
												<div className="col-6">{super.getRoleSetup("nonstriker")!==undefined ? _GPY.toPlayerName( super.getPlayerById(super.getRoleSetup("nonstriker")) ):"-"}</div>
										</div>
										<div className="row">
												<div className="col-6">Bowler:</div>
												<div className="col-6">{super.getRoleSetup("bowler")!==undefined ? _GPY.toPlayerName( super.getPlayerById(super.getRoleSetup("bowler")) ):"-"}</div>
										</div>


										<div className="row">
												<div className="col-12">
												{super.getRoleSetup("striker")!==undefined&&super.getRoleSetup("nonstriker")!==undefined&&super.getRoleSetup("bowler")!==undefined?
														<GpyKeybindingButton className={"btn btn-sm btn-block btn-primary"} scoreboard={this.props.scoreboard} title={"Set Runs"} stateName={this.props.stateName+"_button_set_score"} onClick={(e)=>{
															this.setBallData();
														}} />
												:""}
												</div>
										</div>
								</div>


								</div>



								<div className="row"><div className="col-12"><ScoreboardFreeTextPanel scoreboard={this} /></div></div>
								<div className="row"><div className="col-12" style={{height:"300px",overflowY: "scroll"}}>
										<GpyGameLog stateName="gamelog" scoreboard={this} game={this.state.currentGame} onLoad={ (log) => {}}/>
								</div></div>

					 </div>
					 <div className="col-sm col-md col-lg col-xl">
					 			<div className="row">
										<div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">

											<ScoreboardSetupSingleSelect name="overs" scoreboard={this} default={20} items={[20,50]} onChange={(item)=>{
													var ds = this.state.dataStore;
													ds.setup.overs = parseInt(item);
													this.setState({"dataStore":ds},()=>{
														this.openBallData();
													});
											}}/>
											<ScoreboardPeriods scoreboard={this} periodCount={2}
											onActivate={(period)=>{
														this.setState({currentSet:period},()=>{
															this.openBallData();
														});
											}}/>

											<ScoreboardTeamDefaultButtons scoreboard={this}/>
											<ScoreboardStats scoreboard={this}/>
											<ScoreboardAdvertisementTournament scoreboard={this}/>

										</div>
										<div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
														<div className="row">
															<div className="col-6">
																	<strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_playerlist_home_title')}</strong>
																	<GpyTeamList scoreboard={this} exclusionRoles="" game={this.state.currentGame} vsRole="HOME_TEAM_PLAYER" stateName={this.state.NAME+"_teamlist_home_player"}
																			roleSetup={[{name:"striker",title:"S"},{name:"nonstriker",title:"N"},{name:"bowler",title:"B"}]}
																	/>
														   </div><div className="col-6">
																	<strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_playerlist_guest_title')}</strong>
																	<GpyTeamList scoreboard={this} exclusionRoles="" game={this.state.currentGame} vsRole="GUEST_TEAM_PLAYER" stateName={this.state.NAME+"_teamlist_guest_player"}
																			roleSetup={[{name:"striker",title:"S"},{name:"nonstriker",title:"N"},{name:"bowler",title:"B"}]}
																	/>
															 </div>
														</div>
										</div>

								</div>
					   </div>
					</div>

 :<div>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_warn_message_selectgame')}</div>}
		</>
   )
  }
}
export default SBCricket;
